import { CommunityDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CommunityActions from './community.actions';

export const COMMUNITY_FEATURE_KEY = 'community';

export interface CommunityState extends EntityState<CommunityDto> {
  selectedCommunityId?: string | number; // which Community record has been selected
  loaded: boolean; // has the Community list been loaded
  error?: string | null; // last none error (if any)
}

export interface CommunityPartialState {
  readonly [COMMUNITY_FEATURE_KEY]: CommunityState;
}

export const communityAdapter: EntityAdapter<CommunityDto> = createEntityAdapter<
  CommunityDto
>({
  selectId: (community) => community.id,
  sortComparer: false,
});

export const initialState: CommunityState = communityAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedCommunityId: null,
});

const communityReducer = createReducer(
  initialState,
  on(CommunityActions.loadCommunity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CommunityActions.loadCommunitySuccess, (state, { community }) =>
    communityAdapter.addAll(community, { ...state, loaded: false })
  ),
  on(CommunityActions.loadCommunityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CommunityActions.addCommunity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CommunityActions.addCommunitySuccess, (state, { newCommunity }) =>
    communityAdapter.addMany(newCommunity, { ...state, loaded: false })
  ),
  on(CommunityActions.addCommunityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CommunityActions.updateCommunity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CommunityActions.updateCommunitySuccess, (state, { updateCommunity }) =>
    communityAdapter.upsertMany(updateCommunity, { ...state, loaded: false })
  ),
  on(CommunityActions.updateCommunityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CommunityActions.removeCommunity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CommunityActions.removeCommunitySuccess, (state, { ids }) =>
    communityAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(CommunityActions.removeCommunityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: CommunityState | undefined, action: Action) {
  return communityReducer(state, action);
}
